import styled from 'styled-components';

const MarginX = styled.div`
  margin: 0 5px;
`;

export default MarginX;
